import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import Vertical_1 from "../../assests/images/vertical_1.jpg";
import Vertical_2 from "../../assests/images/vertical_2.jpg";
import Horizontal_4 from "../../assests/images/horizontal_4.jpg";

const events = [
  {
    id: 1,
    title: "ASME x Standard Chartered x Nextloop",
    date: "Q2 2026",
    venue: "Standard Chartered Marina Bay Financial",
    image: Vertical_1,
    description: "Coming Soon",
    timeline: [{ time: "", activity: "Coming Soon" }],
  },
  {
    id: 2,
    title: "ASME x Knight Frank x Nextloop",
    date: "Q2 2026",
    venue: "Ocean Financial Centre",
    image: Vertical_2,
    description: "Coming Soon",
    timeline: [{ time: "", activity: "Coming Soon" }],
  },
  {
    id: 3,
    title: "Youth Business Summit",
    date: "Q1 2027",
    venue: "TBC",
    image: Horizontal_4,
    description: "Coming Soon",
    timeline: [{ time: "", activity: "Coming Soon" }],
  },
];

export default function GatewaySection() {
  const [index, setIndex] = useState(0);

  // Auto switch event every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % events.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative px-6 lg:px-12 bg-gray-50">
      {/* Section Header */}
      <div className="max-w-7xl mx-auto text-center mb-12">
        <h2 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
          NextLoop <span className="text-[#92abc4]">Gateway</span>
        </h2>
        <p className="max-w-3xl text-gray-500 leading-relaxed mx-auto">
          From spotlight to handshakes. Converting global stakeholders, enabling cross-sector
          collaboration, and turning conversations into lasting partnerships.
        </p>
      </div>

      {/* Main Content: Side-by-side on desktop, stacked on mobile */}
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-12 lg:gap-16 items-start">
        
        {/* Carousel */}
        <div className="relative w-full lg:w-1/2 h-[400px] sm:h-[400px] md:h-[350px] lg:h-[350px]">
          <AnimatePresence mode="wait">
            {events[index] && (
              <motion.div
                key={events[index].id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.8, ease: "easeInOut" }}
                className="absolute inset-0 rounded-3xl overflow-hidden shadow-xl"
              >
                <img
                  src={events[index].image}
                  alt={events[index].title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                <div className="absolute bottom-6 left-6 right-6 text-left text-white">
                  <h3 className="text-2xl font-semibold">{events[index].title}</h3>
                  <p className="text-sm mt-1">{events[index].date}</p>
                  <p className="text-sm">{events[index].venue}</p>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        {/* Feature List */}
        <ul className="flex-1 space-y-6 text-gray-700 text-left">
          {[
            {
              number: "1",
              title: "Convert Global Stakeholders",
              desc: "Reach decision-makers and build lasting partnerships worldwide.",
            },
            {
              number: "2",
              title: "Enable Cross-Sector Collaboration",
              desc: "Bridge industries and sectors to turn conversations into real impact.",
            },
            {
              number: "3",
              title: "Power the NextLoop Ecosystem",
              desc: "Leverage our network of 150+ organisations and 10,000+ individuals.",
            },
          ].map((item) => (
            <li key={item.number} className="flex gap-4">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-indigo-500 text-white font-medium">
                {item.number}
              </span>
              <div>
                <p className="font-semibold">{item.title}</p>
                <p className="text-sm">{item.desc}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
